import * as Yup from 'yup'
import FormBuilder, { FormFields } from "app/modules/tp/builders/FormBuilder";
import { Client } from "../_models";

const formFields: FormFields<Client> = {
    title0: {
        type: "titleView",
        title: "Info",
        icon: <i className="fa-solid fa-toolbox"></i>
    },
    id: {
        type: "text",
        key: "id",
        label: "# ID",
        attributes: {
            disabled: true
        },
        validation: Yup.number().integer().nullable(),
    },
    business_name:
    {
        type: "text",
        key: "business_name",
        label: "Ragione sociale / Nome e Cognome",
        validation: Yup.string()
            .max(50, 'La Ragione sociale deve essere di massimo 50 caratteri')
            .required('La Ragione sociale / Nome e Cognome è obbligatoria'),
    },
    email: {
        type: "text",
        key: "email",
        label: "Email",
        validation: Yup.string().nullable()
            .max(50, 'L\'email deve essere di massimo 50 caratteri')
            .email('L\'email deve essere valida'),
    },
    displayed_name: {
        type: "text",
        key: "displayed_name",
        label: "Nome visualizzato",
        validation: Yup.string().nullable()
            .max(50, 'Il nome visualizzato deve essere di massimo 50 caratteri'),
    },
    fiscal_code:
    {
        type: "text",
        key: "fiscal_code",
        label: "Codice fiscale",
        validation: Yup.string().nullable()
            .test('len', 'Il Codice fiscale deve essere di 16 o 11 caratteri', val => (val?.length === 16) || (val?.length === 11) || (!val || val?.length === 0)),
    },
    vat_number:
    {
        type: "text",
        key: "vat_number",
        label: "Partita IVA",
        validation: Yup.string().nullable()
            .length(11, 'La Partita IVA deve essere di 11 caratteri'),
    },
    sdi:
    {
        type: "text",
        key: "sdi",
        label: "SDI",
        validation: Yup.string().nullable()
            .min(6, 'Lo SDI deve avere almeno 6 caratteri')
            .max(7, 'Lo SDI deve avere al massimo 7 caratteri'),
    },
    pec: {
        type: "text",
        key: "pec",
        label: "PEC",
        validation: Yup.string().nullable()
            .max(50, 'L\'email PEC deve essere di massimo 50 caratteri')
            .email('L\'email PEC deve essere valida'),
    },
    city:
    {
        type: "text",
        key: "city",
        label: "Città",
        validation: Yup.string().nullable()
            .max(50, 'La città deve essere di massimo 50 caratteri'),
    },
    address:
    {
        type: "text",
        key: "address",
        label: "Indirizzo",
        validation: Yup.string().nullable()
            .max(128, 'Il nome visualizzato deve essere di massimo 50 caratteri'),
    },
    province:
    {
        type: "text",
        key: "province",
        label: "Provincia",
        validation: Yup.string().nullable()
            .max(50, 'La provincia deve essere di massimo 50 caratteri'),
    },
    zip_code:
    {
        type: "text",
        key: "zip_code",
        label: "CAP",
        validation: Yup.string().nullable()
            .max(5, 'Il CAP deve essere di massimo 50 caratteri'),
    },
    phone:
    {
        type: "text",
        key: "phone",
        label: "Telefono",
        validation: Yup.string().nullable()
            .matches(/^(\+)?[0-9]+$/, 'Il telefono deve essere valido'),
    },
    note:
    {
        type: "wysiwyg",
        key: "note",
        label: "Note",
        validation: Yup.string().nullable()
            .max(500, 'La nota deve essere di massimo 500 caratteri'),
    },
}


const ClientFormBuilder = () => (FormBuilder<Client>({ formFields }))

export default ClientFormBuilder;
